import { ParameterType } from '@/study-search/enums';

import { IIndexation } from '../../../interfaces';
import { SingleValueFilter } from '../SingleValueFilter';
import { FilterKey } from '@studyportals/search-filters/server-side';

export class OrganisationFilter extends SingleValueFilter implements IIndexation {
	public constructor() {
		super(FilterKey.ORGANISATIONS, ParameterType.ORGANISATIONS, []);
	}
}
